import axios from "axios";
import store from "@/store/index";

const defaultConfig = {
  url: process.env.VUE_APP_SERVER_URL,
};

export class Api {
  constructor(config) {
    config = config ? config : defaultConfig;
    this.api = axios.create(config);

    // Request interceptor: attach auth token.
    this.api.interceptors.request.use(
      (config) => {
        return {
          ...config,
          headers: {
            ...config.headers,
            Accept: "application/json",
            Authorization: `Bearer ${store.getters.authToken || ""}`,
          },
        };
      },
      (error) => Promise.reject(error),
    );

    // Response interceptor: log out on 401.
    this.api.interceptors.response.use(undefined, (err) => {
      if (err.response && err.response.status === 401) {
        store.commit("logoutAuth");
      }
      return Promise.reject(err);
    });
  }

  getUri(config) {
    return this.api.getUri(config);
  }

  request(config) {
    return this.api.request(config);
  }

  get(url, config) {
    return this.api.get(url, config);
  }

  delete(url, config) {
    return this.api.delete(url, config);
  }

  head(url, config) {
    return this.api.head(url, config);
  }

  post(url, data, config) {
    return this.api.post(url, data, config);
  }

  put(url, data, config) {
    return this.api.put(url, data, config);
  }

  patch(url, data, config) {
    return this.api.patch(url, data, config);
  }
}
